<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header"><span class="title_head">Search Product</span></div>
            <div class="row">
              <div class="col-sm-12">
                <div v-if="hasErrors.message" class="alert alert-success" >
                  <center>{{errorMessage.message}}</center>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                  <label for="name">Product Name</label>
                  <input type="text" name="" autocomplete="off" class="form-control" placeholder="Enter Product Name" v-model="pdname">
                  <!--<input type="text" name="" autocomplete="off" class="form-control" placeholder="Enter Product Name" @blur.native="chkProductExist()" v-model="pdname">-->
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                  <label for="name">Product Description</label>
                  <input type="text" name="" autocomplete="off" placeholder="Product Description" class="form-control" v-model="pdid">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="name"></label>
                  <button type="button" v-show="prod_view === true" class="btn  btn-pill btn-primary serach_bttn" @click.prevent="getproducttl" style="margin-top: 24px;">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <span class="title_head">List Product</span>&nbsp;&nbsp;
              <span v-if="prod_rights === true">
                <button type="button" class="btn btn-sm btn-primary label_bttn" variant="secondary" @click="openproduct"><i class="fa fa-plus"></i> Add Product</button>
                <!-- <button type="button" class="btn btn-sm btn-primary label_bttn" variant="secondary" @click="addProduct"><i class="fa fa-plus"></i> Add Product</button> -->
              </span>
            </div>
            <vue-good-table 
            :columns="columns" 
            :rows="rows"
            mode="remote"
            ref="my-table"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :paginationOptions="{enabled: true, perPage: 5}" 
            styleClass="vgt-table striped bordered table-sm condensed">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">

                  <span v-if="prod_rights === true">
                    <i class="fa fa-eye" @click.prevent="viewpro(props.row)" style="color:rgb(99, 194, 222) !important;"></i>
                      <span v-if="props.row.company_id !== 'I2OCGLB'">
                        <i class="fa fa-edit" @click.prevent="editpro(props.row)" style="color:rgb(99, 194, 222) !important;"></i>
                      </span>
                      <span v-else>
                      <!-- <span v-if="is_admin === true">
                       <i class="fa fa-edit" @click.prevent="editpro(props.row)" style="color:rgb(99, 194, 222) !important;"></i>
                      </span>
                      <span v-else> -->
                        <i class="fa fa-edit" style="color:grey !important;"></i>
                      <!-- </span> -->
                    </span>
                  </span>
                  <span v-else>
                    <i class="fa fa-eye" @click.prevent="viewpro(props.row)" style="color:grey !important;"></i>
                    <i class="fa fa-edit" style="color:grey !important;"></i>
                  </span>
                </span>
                <span v-else-if="props.column.field == 'product_description'">
                  {{strip_html_tags(props.row.product_desc)}}
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
              <div slot="emptystate" style="text-align:center;" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
              </div>
            </vue-good-table>

            <b-modal title="Product Detail" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-info" v-model="largeModal" @ok="largeModal = false">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Name<span style="color:red"> *</span></label>
                    <input type="text" class="form-control" autocomplete="off" id="productname" :class="{'is-invalid':hasErrors.productname}"  name="productname" v-model="product.productname"  placeholder="Enter Product Name">
                    <small  class="form-text text-muted" v-if="hasErrors.productname" ><strong style="color: red;"> {{errorMessage.productname}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Category<span style="color:red"> *</span></label>
                    <model-list-select 
                      :list="category" 
                      class="form-control" 
                      :class="{'is-invalid': hasErrors.category}"
                      style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" 
                      option-value="category_name" 
                      option-text="category_name" 
                      v-model="selectedCategory" 
                      placeholder="Select Category" 
                      @input="subcategory1"
                    />
                    <small class="form-text text-muted" v-if="hasErrors.category">
                      <strong style="color: red;">{{errorMessage.category}}</strong>
                    </small>
                  </div>
                </div>
                
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Sub Category</label>
                    <model-list-select :list="subcategory" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="sub_category_name" option-text="sub_category_name" v-model="selectedSub" placeholder="Select Sub Category"></model-list-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Brand</label>
                    <model-list-select :list="brndopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="brand_name" option-text="brand_name" v-model="selectedBrand" placeholder="Select Brand"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">HSN Code <span style="color:red"> *</span></label>
                    <!-- <label for="name">HSN Code </label> -->
                    <model-list-select :list="hsnopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="hsn_id" option-text="hsn_code" v-model="selectedHsn" placeholder="Select Hsn" @input="tax_name_2"></model-list-select>
                     <small  class="form-text text-muted" v-if="errorMessage.selectedHsn" ><strong style="color: red;"> {{errorMessage.selectedHsn}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Tax <span style="color:red"> *</span></label>
                    <!-- <label for="name">Tax </label> -->
                    <model-list-select readonly :list="taxopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="tax_name" option-text="tax_name" v-model="selectedTax" placeholder="Select Tax"></model-list-select>
                    <small  class="form-text text-muted" v-if="errorMessage.selectedTax" ><strong style="color: red;"> {{errorMessage.selectedTax}}</strong></small>
                  </div>
                </div>
              </div>
              
              <div class="row">

                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Unit</label>
                    <model-list-select :list="unitopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="unit_name" option-text="unit_name" v-model="selectedUnit" placeholder="Select Unit"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4" >
                  <div class="form-group" >
                    <label for="name">SKU</label>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.altproductid}" autocomplete="off"  v-model="product.altproductid" placeholder="Enter SKU">
                    <small class="form-text text-muted" v-if="hasErrors.altproductid" ><strong style="color: red;">Enter Valid Product Id</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Variant</label>
                    <model-list-select class="form-control" :list="varientlist" option-value="variant_id" option-text="variant_name" v-model="product.variantname" placeholder="Select Variant" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                    <small  class="form-text text-muted" v-if="hasErrors.variantname" ><strong style="color: red;">Enter Valid Variant Name</strong></small>
                  </div> 
                </div>
              </div>
 
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Product Description</label>
                    <vue-editor id="productdesc" name="productdesc" :class="{'is-invalid':hasErrors.productdesc}" v-model="product.productdesc" ></vue-editor>
                    <small  class="form-text text-muted" v-if="hasErrors.productdesc" ><strong style="color: red;">Enter Valid Product Description</strong></small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 1 :</label>
                    <b-form-file name="product.image1" :state="Boolean(errorMessage.image1==null)" accept="image/*" id="image1" placeholder="Choose a file..."  ref="fileinput1"></b-form-file>
                    <p v-if="product.imageArr[0]">View Image <a :href="product.imageUrl[0]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image1" ><strong style="color: red;">{{errorMessage.image1}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 2 :</label>
                    <b-form-file name="product.image2" :state="Boolean(errorMessage.image2==null)" accept="image/*" id="image2" placeholder="Choose a file..."  ref="fileinput2"></b-form-file>
                    <p v-if="product.imageArr[1]">View Image <a :href="product.imageUrl[1]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image2" ><strong style="color: red;">{{errorMessage.image2}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 3 :</label>
                    <b-form-file name="product.image3" :state="Boolean(errorMessage.image3==null)" accept="image/*" id="image3" placeholder="Choose a file..."  ref="fileinput3"></b-form-file>
                    <p v-if="product.imageArr[2]">View Image <a :href="product.imageUrl[2]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image3" ><strong style="color: red;">{{errorMessage.image3}}</strong></small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 4 :</label>
                    <b-form-file name="product.image4" :state="Boolean(errorMessage.image4==null)" accept="image/*" id="image4" placeholder="Choose a file..."  ref="fileinput4"></b-form-file>
                    <p v-if="product.imageArr[3]">View Image <a :href="product.imageUrl[3]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image4" ><strong style="color: red;">{{errorMessage.image4}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 5 :</label>
                    <b-form-file name="product.image5" :state="Boolean(errorMessage.image5==null)" accept="image/*" id="image5" placeholder="Choose a file..."  ref="fileinput5"></b-form-file>
                    <p v-if="product.imageArr[4]">View Image <a :href="product.imageUrl[4]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image5" ><strong style="color: red;">{{errorMessage.image5}}</strong></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Image 6 :</label>
                    <b-form-file name="product.image6" :state="Boolean(errorMessage.image6==null)" accept="image/*" id="image6" placeholder="Choose a file..."  ref="fileinput6"></b-form-file>
                    <p v-if="product.imageArr[5]">View Image <a :href="product.imageUrl[5]" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                    <small class="form-text text-muted" v-if="errorMessage.image6" ><strong style="color: red;">{{errorMessage.image6}}</strong></small>
                  </div>
                </div>
              </div>

              <hr>
              
              <div class="row">
                <div class="col-sm-4">
                  <label for="name">Product Specification :</label>
                </div>
                <div class="col-sm-6">
                  <label for="name">Product Specification Description</label> 
                </div>
                <div class="col-sm-2"></div>
              </div>

              <div class="row" v-for="(spec, index) in specs">
                <div class="col-sm-4">
                  <div class="form-group">
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.specname}" autocomplete="off" v-model="spec.specname" placeholder="Enter Product Specification">
                    <small  class="form-text text-muted" v-if="hasErrors.specname" ><strong style="color: red;">Enter Valid Specification  Name</strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                   <div class="form-group">
                      <input type="text" class="form-control" :class="{'is-invalid':hasErrors.specdesc}" autocomplete="off" v-model="spec.specdesc" placeholder="Enter Product Specification Description">
                      <small  class="form-text text-muted" v-if="hasErrors.specdesc" ><strong style="color: red;">Enter Valid Specification Description</strong></small>
                   </div>
                </div>
                <div class="col-sm-2" style="margin-top: 3px;">
                  <div class="form-group">
                   <button @click="addRow" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i></button>
                   <button v-on:click="removeElement(index);" v-if="(index != 0)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
                  </div>
                </div>
              </div>
              

              <hr>

               <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 1</label> 
                  <input type="text" class="form-control" id="productcf1" :class="{'is-invalid':hasErrors.productcf1}" autocomplete="off" v-model="product.productcf1" name="productcf1" placeholder="Custom Field Label 1">
                  <small  class="form-text text-muted" v-if="hasErrors.productcf1" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 2</label> 
                  <input type="text" class="form-control" autocomplete="off"  v-model="product.productcf2" placeholder="Custom Field Label 2">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                  <label for="name">Custom Field 3</label> 
                  <input type="text" class="form-control"  v-model="product.productcf3" placeholder="Custom Field Label 3">
                  </div>
                </div>
                 <div class="col-sm-3">
                  <div class="form-group">
                    <b-form-checkbox id="checkbox1" v-model="checkboxqty" value="true" unchecked-value="false">Alert Quantity</b-form-checkbox>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.productalert}" v-model="product.productalertqty" placeholder="Enter Alert Quantity">
                    <small class="form-text text-muted" v-if="hasErrors.productalert" ><strong style="color: red;">Enter Valid Product Alert Quantity</strong></small>
                  </div>
                </div> 
                </div>

              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                                 <input type="text" class="form-control" id="productcf_val1" :class="{'is-invalid':hasErrors.productcf_val1}" autocomplete="off" v-model="product.productcf_val1" name="productcf_val1" placeholder="Custom Field value 1">
                  <small  class="form-text text-muted" v-if="hasErrors.productcf_val1" ><strong style="color: red;">Enter Valid Product Classification</strong></small>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                
                  <input type="text" class="form-control" autocomplete="off"  v-model="product.productcf_val2" placeholder="Custom Field value 2">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                 
                  <input type="text" class="form-control"  v-model="product.productcf_val3" placeholder="Custom Field value 3">
                  </div>
                </div>
               
              </div>
              <br v-if="1 === 2">
              <div class="row">
                <div class="col-sm-6" v-if="1 === 2">
                  <div class="form-group">
                    <b-form-checkbox @input="hasBarcode()" value="1" unchecked-value="0">I have product barcode number</b-form-checkbox>
                    <input type="text" class="form-control" :class="{'is-invalid':hasErrors.productbarcodesymbol}" v-model="product.productbarcodesymbol" placeholder="Enter Barcode Number" :disabled="disabled == 0 ? false : true">
                    <small class="form-text text-muted" v-if="hasErrors.productbarcodesymbol" ><strong style="color: red;">{{ errorMessage.productbarcodesymbol }}</strong></small>
                  </div>
                </div> 
                <div class="col-sm-4" style="margin-top: 28px;">
                    <b-form-checkbox v-model="checkboxtk" value="true" unchecked-value="false"> Product Track Quantity </b-form-checkbox>
                </div>
              </div>
              <div v-show="show_save_btn" class="card-footer modal_footer"><button type="submit" class="btn btn-sm btn-primary" @click.prevent="Submit()"><i class="fa fa-dot-circle-o"></i> Save</button></div>
            </b-modal>

            <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only 
            v-model="plan_modal"
          >
          <b-row>
            <b-col sm="2">
                <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding Product. Please upgrade your plan to add more Products.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>

            <!--


            <b-modal title="Product Detail" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-info" v-model="largeModal1" @ok="largeModal1 = false">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Product Name<span style="color:red"> *</span></label>
                    <input type="text" disabled class="form-control" v-model="product.productname" placeholder="Enter Product Name">
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Category</label>
                    <model-list-select :list="category" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214); min-height: 35px;" option-value="category_name" option-text="category_name" v-model="selectedCategory" placeholder="Select Category"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Sub Category</label>
                    <model-list-select :list="subcategory" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="sub_category_name" option-text="sub_category_name" v-model="selectedSub" placeholder="Select Sub Category"></model-list-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Brand</label>
                    <model-list-select :list="brndopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="brand_name" option-text="brand_name" v-model="selectedBrand" placeholder="Select Brand"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">HSN Code</label>
                    <model-list-select :list="hsnopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="hsn_id" option-text="hsn_code" v-model="selectedHsn" placeholder="Select Hsn"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Tax <span style="color:red"> *</span></label>
                    <model-list-select :list="taxopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="tax_name" option-text="tax_name" v-model="selectedTax" placeholder="Select Tax"></model-list-select>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Unit</label>
                    <model-list-select :list="unitopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="unit_name" option-text="unit_name" v-model="selectedUnit" placeholder="Select Unit"></model-list-select>
                  </div>
                </div>
                <div class="col-sm-4" >
                  <div class="form-group" >
                    <label for="name">SKU</label>
                    <input type="text" disabled class="form-control" v-model="product.altproductid" placeholder="Enter SKU">
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="name">Variant</label>
                    <model-list-select class="form-control" :list="varientlist" option-value="variant_id" option-text="variant_name" v-model="product.variantname" placeholder="Select Variant" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                  </div> 
                </div>
              </div>

              <hr>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Product Description</label>
                    <p style="background-color: #f9f9f9; padding-top: 5px; padding-left: 5px; padding-right: 5px; padding-bottom: 5px;" v-html="product.productdesc">{{product.productdesc}}</p>
                  </div>
                </div>
              </div>

              <hr>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Product Images</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-1">
                  <span v-if="product.imageArr[0]"><a :href="product.imageUrl[0]" target="blank"><img :src="product.imageUrl[0]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
                <div class="col-sm-1">
                  <span v-if="product.imageArr[1]"><a :href="product.imageUrl[1]" target="blank"><img :src="product.imageUrl[1]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
                <div class="col-sm-1">
                  <span v-if="product.imageArr[2]"><a :href="product.imageUrl[2]" target="blank"><img :src="product.imageUrl[2]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
                <div class="col-sm-1">
                  <span v-if="product.imageArr[3]"><a :href="product.imageUrl[3]" target="blank"><img :src="product.imageUrl[3]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
                <div class="col-sm-1">
                  <span v-if="product.imageArr[4]"><a :href="product.imageUrl[4]" target="blank"><img :src="product.imageUrl[4]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
                <div class="col-sm-1">
                  <span v-if="product.imageArr[5]"><a :href="product.imageUrl[5]" target="blank"><img :src="product.imageUrl[5]" class="img-thumbnail" width="50px" height="50px"></a></span>
                </div>
              </div>

              <hr>
              
              <div class="row">
                <div class="col-sm-4">
                  <label for="name"><b>Product Specification</b></label>
                </div>
                <div class="col-sm-8">
                  <label for="name"><b>Product Specification Description</b></label> 
                </div>
              </div>

              <div class="row" v-for="(spec, index) in specs">
                <div class="col-sm-4">
                  {{spec.specname}}
                </div>
                <div class="col-sm-8">
                  : {{spec.specdesc}}
                </div>
              </div>
              

              <hr>

              <div class="row">
                <div class="col-sm-4">
                  <label for="name">Custom Field 1 : {{product.productcf1}}</label> 
                </div>
                <div class="col-sm-4">
                  <label for="name">Custom Field 2 : {{pcf.cf2}}</label> 
                </div>
                <div class="col-sm-4">
                  <label for="name">Custom Field 3 : {{pcf.cf3}}</label> 
                </div>
              </div>

              <div class="row">
                <div class="col-sm-4">
                  Alert Quantity : {{product.productalertqty}}
                </div>
                <div class="col-sm-8">
                  <label for="name">Barcode Number : {{product.productbarcodesymbol}}</label> 
                </div>
              </div>
            </b-modal>
          -->
          </b-card>
        </b-col>
      </b-row>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
  import { VueEditor } from 'vue2-editor'
  import Spinner from '../../spinner.vue'
  export default {
    components: {
      VueEditor,
      Spinner
    },

    data(){
      return{
        // is_admin: false,
        plan_modal:false,
        tnl_time:false,
        cf_time:false,
        scf_time:false,
        uf_time:false,
        bf_time:false,
        hf_time:false,
        vf_time:false,
        pf_time:false,
        rsf_time:false,
        access_token:null,
        disabled:1,
        pluscheck:false,
        largeModal:false,
        productedit:0,
        producteditvalue:null,
        loading:false,
        checkboxqty:false,
        checkboxtk:false,
        varientlist:[],
        pdid:'',
        pdname:'',
        show_save_btn:false,
        columns: [
        {
          label: 'Product Name',
          field: 'product_name',
          width: '30%'
        },
        {
          label: 'Product Description',
          field: 'product_description',
          width: '45%'
        },
        {
          label: 'Barcode',
          field: 'product_barcode_symbol',
          width: '20%'
        },
        {
          label: 'Edit',
          field: 'action',
          width: '5%'
        },
        ],
        rows:[],
        totalRecords: 0,
        serverParams: {
        columnFilters: {
                   },
        sort: {
          // field: 'purchase_id', 
          // type: 'asc',
              },
        page: 1, 
        perPage: 5
      },
        category: [],
        unitopt: [],
        brndopt: [],
        hsnopt: [],
        taxopt: [],
        specs: [],
        subcategory:[],
        subcategory_all:[],
        selectedCategory: null,
        allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        maximumSize: 500000,
        selectedSub:null,
        selectedBrand:null,
        selectedUnit:null,
        selectedHsn:'',
        selectedTax:'',
        product:{
          altproductid:'',
          productname:'',
          productdesc:'',
          productbarcodesymbol:'',
          productalertqty:'',
          productcf1:'',
          productcf2:'',
          productcf3:'',
          productcf_val1:'',
          productcf_val2:'',
          productcf_val3:'',
          specname:'',
          specdesc:'',
          variantname:null,
          image1:null,
          image2:null,
          image3:null,
          image4:null,
          image5:null,
          image5:null,
          imageArr:[],
          imageUrl:[],
        },
        indx:0,
        hasErrors:{
          message:false ,
          altproductid:false,
          productname:false,
          category: false,
          productdesc:false,
          productcode:false,
          productalert:false,
          productcf1:false,
          productcf2:false,
          productcf3:false,
          productcf_val1:false,
          productcf_val2:false,
          productcf_val3:false,
          specname:false,
          specdesc:false,
          variantname:false,
          image:false,
          selectedHsn:false,
          selectedTax:false,
          productbarcodesymbol:false,
        },
        errorMessage:{
          message:null,
          image1:null,
          image2:null,
          image3:null,
          image4:null,
          image5:null,
          image6:null,
          selectedHsn:'',
          selectedTax:'',
          productbarcodesymbol:'',
        }
      }
    },
    computed:{
      prod_view: function(){
        // console.log(this.$store.getters.get_prod_view)
        if(this.$store.getters.get_prod_view === true){
          this.getCategories('comp')
          this.unit_name('comp')
          this.tax_name_list('comp')
          this.brand_name('comp')
          this.hsnno('comp')
          this.getvariant('comp')
          this.getproducttl('comp')
          this.reset_specs('comp')
          return true
          //  Promise.all([this.getCategories('comp'),this.unit_name('comp'),this.tax_name_list('comp'),this.brand_name('comp'),this.hsnno('comp'), this.getvariant('comp'), this.getproducttl('comp'), this.reset_specs('comp')]).then(ret_val => {
          //     return true
          //   });
        }
        else{
          return false
        }
      },
      prod_rights: function(){
        return this.$store.getters.get_prod_rights
      }
    },
    created(){
      if(localStorage.authUser != null){
        this.access_token = '?access_token='+localStorage.authUser
      }
    },
    
    methods:{
      updateParams(newProps) {  
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
           this.updateParams({page: params.currentPage});
           this.getproducttl();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.getproducttl();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.getproducttl();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.getproducttl();
    },
      hasBarcode(){
        this.disabled = (this.disabled + 1) % 2
        this.hasErrors.productbarcodesymbol = false
        this.errorMessage.productbarcodesymbol = ''
      },
      strip_html_tags(str){
        if ((str===null) || (str==='')){
          return null;
        }
        else{
          str = str.toString();
          return str.replace(/<[^>]*>/g, ' ');
        }
      },

      reset_specs(val){
        if(val === 'comp'){
          if(this.rsf_time === false){
            this.rsf_time = true
          }
          else{
            return
          }
        }
        if(this.specs.length > 0){
          for (var i = this.specs.length-1; i >=0;  i--) {
            this.specs.splice(i,1);
          }
        }
        for (var i = 0; i < 1; i++) {
          this.specs.push({specname:'', specdesc:''})
        }
        // return Promise.resolve(true)
      },
      
      openproduct(){
        var _this = this
        this.loading = true;
        this.$http.get('/api/companyproducts/chk_plan_count').then(function(response){
          _this.loading = false;
          if('message' in response.data){
            if(response.data.message === false){
              _this.plan_modal=false
              _this.errorMessage.image1 = null
              _this.errorMessage.image2 = null
              _this.errorMessage.image3 = null
              _this.errorMessage.image4 = null
              _this.errorMessage.image5 = null
              _this.errorMessage.image6 = null
              _this.$refs.fileinput1.reset()
              _this.$refs.fileinput2.reset()
              _this.$refs.fileinput3.reset()
              _this.$refs.fileinput4.reset()
              _this.$refs.fileinput5.reset()
              _this.$refs.fileinput6.reset()
              _this.product.imageArr = []
              _this.product.imageUrl = []
              _this.show_save_btn=true
              _this.largeModal=true
              _this.reset()
           }
            else{
              _this.plan_modal=true
            }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
      },

      addRow(){
        this.specs.push({specname:'', specdesc:''})
      },

      removeElement: function(index) {
        this.specs.splice(index, 1);
      },

      getvariant(val){
        if(val === 'comp'){
          if(this.vf_time === false){
            this.vf_time = true
          }
          else{
            return
          }
        }
        var _this = this
        this.$http.get('/api/variants').then(function(response){
          // console.log(response.data)
          _this.varientlist=response.data;
          // return Promise.resolve(true)
        }).catch(function(error){
          // return Promise.resolve(true)
        })
      },

      brand_name(val){
        if(val === 'comp'){
          if(this.bf_time === false){
            this.bf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/brands').then(function(response){
          _this.brndopt=  response.data;
          // return Promise.resolve(true)
        })
        .catch(function(error){
          // return Promise.resolve(true)
        })
      },

      unit_name(val){
        if(val === 'comp'){
          if(this.uf_time === false){
            this.uf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/unittypes').then(function(response){
          _this.unitopt=response.data;
          // return Promise.resolve(true);
        }).catch(function(error){
          // return Promise.resolve(true);
          console.log(error)
        })
      },

      tax_name_list(val){
        if(val === 'comp'){
          if(this.tnl_time === false){
            this.tnl_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/taxrates').then(function(response){
          _this.taxopt=response.data;
          // return Promise.resolve(true);
        }).catch(function(error){
          // return Promise.resolve(true);
        })
      },

      tax_name(opt){
        this.selectedTax = null
        var tax_sel = this.taxopt.filter(function(each){
          return each.tax_id === opt
        });
        this.selectedTax = tax_sel[0]
        // var _this=this
        // this.$http.get('/api/taxrates?filter[where][tax_id]='+opt.tax_id).then(function(response){
        //   _this.taxopt = response.data
        //   _this.selectedTax = response.data[0]
        // }).catch(function(error){
        // })
      },

      // tax_name2(opt){
      //   var tax_sel = this.taxopt.filter(function(each){
      //     return each.tax_id === opt
      //   });
      //   this.selectedTax = tax_sel[0]

        // var _this=this
        // this.$http.get('/api/taxrates?filter[where][tax_id]='+opt).then(function(response){
        //   _this.taxopt = response.data
        //   _this.selectedTax = response.data[0]
        // }).catch(function(error){
        // })
      // },

      hsnno(val){
        if(val === 'comp'){
          if(this.hf_time === false){
            this.hf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.$http.get('/api/hsns').then(function(response){
          _this.hsnopt = response.data;
          // return Promise.resolve(true)
        }).catch(function(error){
          console.log(error)
          // return Promise.resolve(true)
        })
      },
      
      subcategory1(category){
        this.subcategory=[]
        this.selectedSub=null
        if(category != null && typeof category === 'object' && 'category_id' in category){
          var _this=this
          var id=category.category_id
          this.$http.get('/api/subcategories?filter[where][category_id]='+id).then(function (response) {
            _this.subcategory=response.data;
          })
          .catch(function (error) {
            console.log(error)
          });
        }
        else{
          // cleared, or the picker handed back a bare name instead of a row -
          // reset to null so the next selection binds the object again
          this.selectedCategory=null
        }
        
      },

      subcategory2(category, subcategory){
        this.subcategory = [];
        this.selectedSub = null
        var _this=this
        var id = category
        this.$http.get('/api/subcategories?filter[where][category_id]='+id).then(function (response) {
          _this.subcategory=response.data;
          if(subcategory !== null){
            var sel_subcat = _this.subcategory.filter(function(each){
                return each.sub_category_id === subcategory
            });
            _this.selectedSub  = sel_subcat[0] || null
          }
        })
        .catch(function (error) {
        });
      },

      getCategories(val){
        if(val === 'comp'){
            if(this.cf_time === false){
              this.cf_time = true
            }
            else{
              return
            }
          }
        var _this=this
        this.$http.get('/api/categories').then(function (response){
          _this.category=response.data;
          // return Promise.resolve(true);
        })
        .catch(function (error) {
          console.log(error)
          // return Promise.resolve(true);
        });
      },

      // async getSubCategories(val){
      //    console.log('getSubCategories')
      //    this.subcategory_all.length = 0
      //   if(val === 'comp'){
      //       if(this.scf_time === false){
      //         this.scf_time = true
      //       }
      //       else{
      //         return
      //       }
      //     }
      //   var _this=this
      //   this.$http.get('/api/subcategories/getAll').then(function(response){
      //     console.log(response)
      //     _this.subcategory_all=response.data;
      //     console.log(_this.subcategory_all)
      //     return Promise.resolve(true);
      //   })
      //   .catch(function (error) {
      //     console.log(error)
      //     return Promise.resolve(true);
      //   });
      // },

      async getCategoriesed(cat, sub_cat){
        var cat_sel = await this.category.filter(function(each){
          return each.category_id === cat
        });
        this.selectedCategory = cat_sel[0] || null
        this.subcategory2(cat, sub_cat)
        // var _this=this
        // this.$http.get('/api/categories?filter[where][category_id]='+cat) .then(function (response) {
        //   _this.selectedCategory=response.data[0]
        //   _this.subcategory2(_this.selectedCategory.category_id)
        // })
        // .catch(function (error) {
        // });
      },

      subcategory1ed(sub){
        // console.log('subcategory1ed')
        // console.log(sub)
        var subcat_sel = this.subcategory_all.filter(function(each){
          return each.sub_category_id === sub
        });
        this.selectedSub = subcat_sel[0]
        // var _this=this
        // this.$http.get('/api/subcategories?filter[where][sub_category_id]='+sub).then(function (response){
        //   _this.selectedSub=response.data[0]
        //   console.log(_this.selectedSub)
        // })
        // .catch(function (error) {
        // });
      },

      brand_nameed(brd){
        // console.log(brd)
        var brand_sel = this.brndopt.filter(function(each){
          return each.brand_id === brd
        });
        this.selectedBrand = brand_sel[0]
        // var _this=this
        // this.$http.get('/api/brands?filter[where][brand_id]='+brd).then(function(response){
        //   _this.selectedBrand=response.data[0]
        // }).catch(function(error){
        // })
      },

      hsnnoed(hsn){
        // console.log(hsn)
        var hsn_sel = this.hsnopt.filter(function(each){
          return each.hsn_id === hsn
        });
        this.selectedHsn = hsn_sel[0]
        this.tax_name(this.selectedHsn.tax_id)
        // var _this=this
        // this.$http.get('/api/hsns/findOne?filter[where][hsn_id]='+hsn).then(function(response){
        //   _this.selectedHsn = response.data
        //   _this.tax_name2(_this.selectedHsn.tax_id)
        // }).catch(function(error){
        // })
      },

      // tax_nameed(opt){
      //   // console.log('taxnameed')
      //   // console.log(opt)
      //   var tax_sel = this.taxopt.filter(function(each){
      //     return each.tax_id === opt
      //   });
      //   this.selectedTax = tax_sel[0]
        
        // var _this=this
        // this.$http.get('/api/taxrates?filter[where][tax_id]='+opt).then(function(response){
        //   _this.selectedTax=response.data[0]
        // }).catch(function(error){
        // })
      // },

      unit_nameed(unit){
        // console.log(unit)
        var unit_sel = this.unitopt.filter(function(each){
          return each.unit_id === unit
        });
        this.selectedUnit = unit_sel[0]
        // var _this=this
        // this.$http.get('/api/unittypes?filter[where][unit_id]='+unit).then(function(response){
        //   _this.selectedUnit=response.data[0]
        // }).catch(function(error){
        // })
      },

      variant_ed(id){
        var variant_sel = this.varientlist.filter(function(each){
          return each.variant_id === id
        });
        this.product.variantname = variant_sel[0]
        // var _this=this
        // this.$http.get('/api/variants?filter[where][variant_id]='+id).then(function(response){
        //   console.log(response.data[0])
        //   // _this.product.variantname=response.data[0]
        // }).catch(function(error){
        // })
      },

      tax_name_2(){
        this.taxopt = []
        this.selectedTax = null
        var _this=this
        this.$http.get('/api/taxrates?filter[where][tax_id]='+this.selectedHsn.tax_id).then(function(response){
          _this.taxopt = response.data
          _this.selectedTax = response.data[0]
        }).catch(function(error){
        })
      },
      
      imagefun1(callback){
        var _this = this
        const image1 = document.querySelector('#image1');
        if(this.product.imageArr[0]){
          if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[0])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return _this.product.imageArr[0]
        }
      }else{
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
      },
    imagefun2(callback){
      var _this = this
      const image2 = document.querySelector('#image2');
      if(this.product.imageArr[1]!=null){
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[1])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[1]
        }
      }else{
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

     
      },
   imagefun3(callback){
      var _this = this
      const image3 = document.querySelector('#image3');
      if(this.product.imageArr[2]!=null){
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[2])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[2]
        }
      }else{
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
        
      },
    imagefun4(callback){
      var _this = this
      const image4 = document.querySelector('#image4');
      if(this.product.imageArr[3]!=null){
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[3])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[3]
        }
      }else{
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

      },
    imagefun5(callback){
      var _this = this
      const image5 = document.querySelector('#image5');
      if(this.product.imageArr[4]!=null){
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[4])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[4]
        }
      }else{
        if(image5.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }

      },
    imagefun6(callback){
     var _this = this
      const image6 = document.querySelector('#image6');
      if(this.product.imageArr[5]!=null){
        if(image6.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.product.imageArr[5])
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return this.product.imageArr[5]
        }
      }else{
        if(image6.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return null;
          });
        }else{
          return null;
        }        
      }
    },

    allImage(id){
      var tempArr=[]
      return this.$http.get('/api/productimages?filter[where][product_id]='+id).then(function(response){
        if(response.data.length!=0){
          return response.data
        }
        else{
          return null
        }
      })
      .catch(function(error){
        return null
      })
    },

      editpro(row){
        this.$refs.fileinput1.reset()
        this.$refs.fileinput2.reset()
        this.$refs.fileinput3.reset()
        this.$refs.fileinput4.reset()
        this.$refs.fileinput5.reset()
        this.$refs.fileinput6.reset()
        this.errorMessage.image1 = null
        this.errorMessage.image2 = null
        this.errorMessage.image3 = null
        this.errorMessage.image4 = null
        this.errorMessage.image5 = null
        this.errorMessage.image6 = null
        this.product.imageArr = []
        this.product.imageUrl = []
        this.show_save_btn=true
        var _this = this
        if(this.specs.length > 0){
          for (var i = this.specs.length-1; i >=0;  i--) {
            this.specs.splice(i,1);
          }
        }
        Promise.all([this.allImage(row.product_id)]).then((user)=>{
          
            for(var i=0;i<user[0].length;i++)
            {
              var imageUrl = _this.$http.defaults.baseURL+'/api/containers/pics/download/'+user[0][i].product_image+_this.access_token
              _this.product.imageArr.push(user[0][i].product_image)
              _this.product.imageUrl.push(imageUrl)
            }
      
        });
        
        _this.hasErrors.altproductid=false;
        _this.hasErrors.productname=false;
        _this.hasErrors.category=false;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.selectedTax=false;
        _this.hasErrors.productdesc=false;
        _this.hasErrors.productcode=false;
        _this.hasErrors.productalert=false;
        _this.hasErrors.productcf1=false; 
        _this.hasErrors.productcf2=false; 
        _this.hasErrors.productcf3=false;
        _this.hasErrors.productcf_val1=false;
        _this.hasErrors.productcf_val2=false;
        _this.hasErrors.productcf_val3=false;
        _this.hasErrors.specdesc=false;
        _this.hasErrors.variantname=false;
        _this.hasErrors.productbarcodesymbol=false;
        this.errorMessage.image1=null;
        this.errorMessage.image2=null;
        this.errorMessage.image3=null;
        this.errorMessage.image4=null;
        this.errorMessage.image5=null;
        this.errorMessage.image6=null;
        this.errorMessage.selectedHsn=null;
        this.errorMessage.selectedTax=null;
        this.errorMessage.productbarcodesymbol='';
        this.largeModal=true
        this.productedit=1;
        this.producteditvalue=row.product_id;
        // console.log(row)
        if(row.category_id!=null){
          this.getCategoriesed(row.category_id,row.sub_category_id)
        }
        // console.log(row.sub_category_id)
        // if(row.sub_category_id!==null){
        //   this.subcategory1ed(row.sub_category_id)
        // }
        if(row.brand_id!=null){
          this.brand_nameed(row.brand_id)
        }
        if(row.hsn_id!=null){
          this.hsnnoed(row.hsn_id)
        }
        if(row.tax_gst_id!=null){
          this.tax_name(row.tax_gst_id)
        }
        if(row.unit_id!=null){
          this.unit_nameed(row.unit_id)
        }
        if(row.variant_id!=null){
          this.variant_ed(row.variant_id)
        }
         

        var prd = row.product_id

        this.$http.get('/api/productspecifications?filter[where][product_id]='+prd).then(function(response){
          var spec_data = response.data
          for (var i = 0; i < spec_data.length; i++) {
            _this.specs.push({specname:spec_data[i].spec_name, specdesc:spec_data[i].spec_desc})
          }
        })
        .catch(function(error){
        })

        


        this.product.altproductid=row.alt_product_id
        this.product.productname=row.product_name
        this.product.productdesc=row.product_desc
        this.product.productbarcodesymbol=row.product_barcode_symbol
        this.product.productalertqty=row.product_alert_qty
        this.product.productcf1=row.product_cf1
        this.product.productcf2=row.product_cf2
        this.product.productcf3=row.product_cf3
        this.product.productcf_val1=row.product_cf1_value
        this.product.productcf_val2=row.product_cf2_value
        this.product.productcf_val3=row.product_cf3_value
       

        if(row.product_alert_qty!=''){
          this.checkboxqty=true;
        }
        this.checkboxtk=row.product_tax_method
        this.checkboxqty=row.product_track_req

      },

      viewpro(row){
        this.show_save_btn=false
        this.largeModal=true
        this.product.imageArr = []
        this.product.imageUrl = []
        var _this = this
        if(this.specs.length > 0){
          for (var i = this.specs.length-1; i >=0;  i--) {
            this.specs.splice(i,1);
          }
        }
        Promise.all([this.allImage(row.product_id)]).then((user)=>{
          for(var i=0;i<user[0].length;i++){
            var imageUrl = _this.$http.defaults.baseURL+'/api/containers/pics/download/'+user[0][i].product_image+_this.access_token
            _this.product.imageArr.push(user[0][i].product_image)
            _this.product.imageUrl.push(imageUrl)
          }
        });
        
        if(row.category_id!=null){
          this.getCategoriesed(row.category_id,row.sub_category_id)
        }
        // if(row.sub_category_id!=null){
        //   this.subcategory1ed(row.sub_category_id)
        // }
        if(row.brand_id!=null){
          this.brand_nameed(row.brand_id)
        }
        if(row.hsn_id!=null){
          this.hsnnoed(row.hsn_id)
        }
        if(row.tax_gst_id!=null){
          this.tax_name(row.tax_gst_id)
        }
        if(row.unit_id!=null){
          this.unit_nameed(row.unit_id)
        }
        if(row.variant_id!=null){
          this.variant_ed(row.variant_id)
        }

        var prd = row.product_id

        this.$http.get('/api/productspecifications?filter[where][product_id]='+prd).then(function(response){
          var spec_data = response.data
          for (var i = 0; i < spec_data.length; i++) {
            _this.specs.push({specname:spec_data[i].spec_name, specdesc:spec_data[i].spec_desc})
          }
        })
        .catch(function(error){
        })

        this.product.altproductid=row.alt_product_id
        this.product.productname=row.product_name
        this.product.productdesc=row.product_desc
        this.product.productbarcodesymbol=row.product_barcode_symbol
        this.product.productalertqty=row.product_alert_qty
        this.product.productcf1=row.product_cf1
        this.product.productcf2=row.product_cf2
        this.product.productcf3=row.product_cf3
        this.product.productcf_val1=row.product_cf1_value
        this.product.productcf_val2=row.product_cf2_value
        this.product.productcf_val3=row.product_cf3_value

        if(row.product_alert_qty!=''){
          this.checkboxqty=true;
        }
        this.checkboxtk=row.product_tax_method
        this.checkboxqty=row.product_track_req
      },

      Submit(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        var _this=this
        _this.hasErrors.altproductid=false;
        _this.hasErrors.productname=false;
        _this.hasErrors.category=false;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.selectedTax=false;
        _this.hasErrors.productdesc=false;
        _this.hasErrors.productcode=false;
        _this.hasErrors.productalert=false;
        _this.hasErrors.productcf1=false;  
        _this.hasErrors.productcf2=false;  
        _this.hasErrors.productcf3=false; 
        _this.hasErrors.productcf_val1=false;
        _this.hasErrors.productcf_val2=false;
        _this.hasErrors.productcf_val3=false;
        _this.hasErrors.specdesc=false;
        _this.hasErrors.variantname=false;
        _this.hasErrors.productbarcodesymbol=false;
        this.hasErrors.image=false;
        this.errorMessage.image1=null;
        this.errorMessage.image2=null;
        this.errorMessage.image3=null;
        this.errorMessage.image4=null;
        this.errorMessage.image5=null;
        this.errorMessage.image6=null;
        this.errorMessage.selectedHsn=null; 
        this.errorMessage.selectedTax=null;
        this.errorMessage.productbarcodesymbol='';
        var fileInput1 = document.querySelector('#image1');
        var fileInput2 = document.querySelector('#image2');
        var fileInput3 = document.querySelector('#image3');
        var fileInput4 = document.querySelector('#image4');
        var fileInput5 = document.querySelector('#image5');
        var fileInput6 = document.querySelector('#image6');
        var submit_true='0';
        var nrex=/^[a-zA-Z0-9\s]{3,100}$/
        var brex=/^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/
        var urex=/^[0-9]{1,9}$/
        if(fileInput1.files[0]!=undefined){
          if(fileInput1.files[0].size>this.maximumSize){
            this.errorMessage.image1="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
          else if( this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image1="Invalid Image Type"
            submit_true='1'
          }else{ this.errorMessage.image1=""}
        }


      if(fileInput2.files[0]!=undefined){
        if(fileInput2.files[0].size>this.maximumSize){
            this.errorMessage.image2="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput2.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image2="Invalid Image Type"
            submit_true='1'
          }
        else{  this.errorMessage.image2=""}
        }

      if(fileInput3.files[0]!=undefined){
        if(fileInput3.files[0].size>this.maximumSize){
            this.errorMessage.image3="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput3.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image3="Invalid Image Type"
            submit_true='1'
          }
        else{ this.errorMessage.image3=""}
        }

      if(fileInput4.files[0]!=undefined){
        if(fileInput4.files[0].size>this.maximumSize){
            this.errorMessage.image4="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput4.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image4="Invalid Image Type"
            submit_true='1'
          }
          else{  this.errorMessage.image4=""}
        }

      if(fileInput5.files[0]!=undefined){
        if(fileInput5.files[0].size>this.maximumSize){
            this.errorMessage.image5="Image Size Cannot Be Greater Than 500kb"
            submit_true='1'
          }
        else if( this.allowableTypes.indexOf(fileInput5.files[0].type.toLowerCase())=== -1){
            this.errorMessage.image5="Invalid Image Type"
            submit_true='1'
          }
        else{ this.errorMessage.image5=""}
        }

        if(fileInput6.files[0]!=undefined){
          if(fileInput6.files[0].size>this.maximumSize){
              this.errorMessage.image6="Image Size Cannot Be Greater Than 500kb"
              submit_true='1'
          }else if( this.allowableTypes.indexOf(fileInput6.files[0].type.toLowerCase())=== -1){
              this.errorMessage.image6="Invalid Image Type"
              submit_true='1'
          }else{
            this.errorMessage.image6=""
          }
        }

        if(this.disabled === 0){

          if(this.product.productbarcodesymbol == ''){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Required"
            submit_true='1'
          }else if(this.product.productbarcodesymbol.length > 20){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Cannot be greater than 20 characters"
            submit_true='1'
          }else if(this.product.productbarcodesymbol.length < 2){
            this.hasErrors.productbarcodesymbol=true;
            this.errorMessage.productbarcodesymbol="Cannot be less than 1 character"
            submit_true='1'
          }
        }

        if(this.product.productname.length > 100){
          this.hasErrors.productname=true;
          this.errorMessage.productname=" Enter maximum 100 characters"
          submit_true='1'
        }

        if(this.product.productname=='')
        {
           this.hasErrors.productname=true;
           this.errorMessage.productname="Required"
           submit_true='1'
        }else{  this.errorMessage.productname=''}

        if(this.selectedCategory==undefined || this.selectedCategory==null || this.selectedCategory.category_id==undefined){
          this.hasErrors.category=true;
          this.errorMessage.category="Required"
          submit_true='1'
        }else{  this.errorMessage.category=''}
        if(this.selectedHsn==undefined || this.selectedHsn==''){
           this.errorMessage.selectedHsn="Required" 
         submit_true='1'
        }else{  this.errorMessage.selectedHsn='' }

        if(this.selectedTax==undefined || this.selectedTax==''){
           this.errorMessage.selectedTax="Required" 
          submit_true='1'
        }else{this.errorMessage.selectedTax='' }

        if (submit_true == '0'){
          Promise.all([this.imagefun1(),this.imagefun2(),this.imagefun3(),this.imagefun4(),this.imagefun5(),this.imagefun6()]).then((user)=>{
            _this.productval(_this,user); 
          });
        }
      },

      productval(_this,user){
        
        var product = {}
        var tempArr = []
        for(var i= 0;i<user.length;i++){
          if(user[i]!= null)
          {
            tempArr.push(user[i])
          }
        }
        if(tempArr.length==0){
          tempArr=null
        }       
        if(this.selectedCategory != undefined && this.selectedCategory.category_id != undefined){ 
          product.category_id=this.selectedCategory.category_id
        }else{
          product.category_id=null
        }
        if(this.selectedSub!=undefined && this.selectedSub.sub_category_id != undefined){
          product.sub_category_id=this.selectedSub.sub_category_id
        }else{
          product.sub_category_id=null
        }
        if(this.selectedUnit!=undefined){
          product.unit_id=this.selectedUnit.unit_id
        }
        if(this.selectedBrand!=undefined){
          product.brand_id=this.selectedBrand.brand_id
        }
        if(this.selectedHsn!=undefined){
          product.hsn_id=this.selectedHsn.hsn_id
        }
        if(this.selectedTax!=undefined){
          product.tax_gst_id=this.selectedTax.tax_id
        }
        if(this.product.variantname!=undefined){
          product.variant_id=this.product.variantname.variant_id
        }
        product.alt_product_id= this.product.altproductid,
        product.product_name= this.product.productname,
        product.product_desc= this.product.productdesc,
        product.product_barcode_symbol= this.product.productbarcodesymbol,
        product.product_alert_qty= this.product.productalertqty,
        product.product_track_req= this.checkboxqty,
        product.product_tax_method= this.checkboxtk,
        product.img=tempArr,
        product.specification='',
        product.specRow = this.specs
        product.product_cf1= this.product.productcf1,
        product.product_cf2=this.product.productcf2,
        product.product_cf3=this.product.productcf3,
        product.product_cf1_value=this.product.productcf_val1,
        product.product_cf2_value=this.product.productcf_val2,
        product.product_cf3_value=this.product.productcf_val3,
        product.disabled=this.disabled
        // console.log(product)
        this.loading=true
        if(this.productedit==0){
          this.$http.post('/api/companyproducts',product) .then(function (response) {
            _this.reset()
            if(response.status===200){
              _this.loading=false
              _this.largeModal=false;
              _this.hasErrors.message=true;
              _this.errorMessage.message='Product Added Successfully';
              _this.getproducttl();
              setTimeout(function(){_this.hasErrors.message=false;}, 4000);
            }else{
              _this.loading=false
              if(user!=null){
                return _this.$http.delete('/api/containers/pics/files/'+user)
              }
            }
          })
          .catch(function (error) {
            _this.loading=false
            if(user!=null){
              return _this.$http.delete('/api/containers/pics/files/'+user)
            }
          });
        }else{
          
          this.$http.post('/api/companyproducts/update?where[product_id]='+this.producteditvalue,product).then(function (response){
            _this.reset()
            if(response.status===200){
              _this.loading=false
              _this.largeModal=false;
              _this.hasErrors.message=true;
              _this.errorMessage.message='Product Updated Successfully';
              _this.getproducttl();
              setTimeout(function(){_this.hasErrors.message=false;}, 4000);
            }else{
              _this.loading=false
              if(user!=null){
                 return _this.$http.delete('/api/containers/pics/files/'+user)
              }
            }               
          })
          .catch(function (error) {
            _this.loading=false
            if(user!=null){
              return _this.$http.delete('/api/containers/pics/files/'+user)
            }
          });
        }
      },

      reset(){
        var _this=this
        _this.reset_specs()
        _this.product.imageArr = []
        _this.product.imageUrl = []
        _this.product.variantname = null
        _this.product.altproductid = ''
        _this.product.productname = ''
        _this.product.productdesc = ''
        _this.product.productbarcodesymbol = ''
        _this.product.productalertqty = '' 
        _this.product.productcf1 = ''
        _this.product.productcf_val1=''
        _this.product.specname = ''
        _this.product.specdesc = ''
        _this.selectedCategory = null 
        _this.subcategory = []
        _this.selectedSubc =null
        _this.selectedBrand = null
        _this.selectedHsn = null               
        _this.selectedTax = null
        _this.selectedUnit = null
        _this.hasErrors.message=false;
        _this.errorMessage.message=   null;
        _this.hasErrors.selectedHsn=false;
        _this.hasErrors.productbarcodesymbol = false
        _this.errorMessage.selectedHsn=   null;
        _this.hasErrors.selectedTax=false;
        _this.errorMessage.selectedTax=   null;
        _this.errorMessage.productbarcodesymbol = ''
        _this.hasErrors.productname=false;
        _this.errorMessage.productname=   null;
        _this.errorMessage.category = null;
        _this.productedit=0;
        _this.producteditvalue=null;
        _this.pluscheck=false;
        _this.product.productcf2='';
        _this.product.productcf3='';
        _this.product.productcf_val2=''
        _this.product.productcf_val3=''
        _this.checkboxqty=false;
        _this.checkboxtk=false;
        _this.selectedSub=null;
        _this.image1=null;
        _this.image2=null;
        _this.image3=null;
        _this.image4=null;
        _this.image5=null;
        _this.image6=null;
        _this.productimagevalue1=null;
        _this.productimagevalue2=null;
        _this.productimagevalue3=null;
        _this.productimagevalue4=null;
        _this.productimagevalue5=null;
        _this.productimagevalue6=null;
      },

      getproducttl(val){
        if(val === 'comp'){
          if(this.pf_time === false){
            this.pf_time = true
          }
          else{
            return
          }
        }
        var _this=this
        this.rows=[];
        // /api/companyproducts/searchprd inner-joins cmp_product_image, so any
        // product without an image row is dropped from the list while still
        // being counted. Read the products straight from /api/companyproducts
        // instead - its beforeRemote('find') hook applies the same company +
        // global scoping and 'id DESC' ordering, with no image join - then do
        // the search and paging here.
        this.loading = true
        this.$http.get('/api/companyproducts').then(function(response){
          _this.loading = false
          var list = response.data || []
          if(_this.pdname != ''){
            var nameTerm = _this.pdname.toLowerCase()
            list = list.filter(function(row){
              return (row.product_name || '').toLowerCase().indexOf(nameTerm) !== -1
            })
          }
          if(_this.pdid != ''){
            var descTerm = _this.pdid.toLowerCase()
            list = list.filter(function(row){
              return (row.product_desc || '').toLowerCase().indexOf(descTerm) !== -1
            })
          }
          _this.totalRecords = list.length
          var perPage = _this.serverParams.perPage
          var page = _this.serverParams.page
          if(perPage !== -1){
            var start = (page - 1) * perPage
            if(start >= list.length){
              start = 0
              _this.serverParams.page = 1
            }
            list = list.slice(start, start + perPage)
          }
          _this.rows = list
        }).catch(function(error){
          console.log(error)
          _this.loading = false
        })
      },
    },
  }
</script>

<style>
  .modal-header{
    background-color: #1a94cb;
    columns: #fff;
  }
  .modal-title{
  color:black;
  font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/addproduct.vue